import React, { FC } from 'react';
import { Select } from 'antd';

import useIndustry from '~/hooks/useIndustry';

interface Props {
  placeholder?: string;

  [x: string]: any;
}

const IndustryInput: FC<Props> = (props) => {
  const { solutionId, ...rest } = props;
  const { codesDict, isLoading } = useIndustry();
  const options = Object.entries(codesDict).map(([, value]) => ({
    label: value.name,
    value: value.id,
  }));

  return <Select loading={isLoading} options={options} {...rest} />;
};

export default IndustryInput;
